export default {
  frameworkApi: {
    projectInfo: {
      getSystemInfo: '/api/framework/projectInfo/getProjectInfo',
      saveOrUpdateInfo: '/api/framework/projectInfo/saveOrUpdateProjectInfo'
    },
    entryManager: {
      getList: '/api/framework/entryManager/getEntryList',
      saveEntry: '/api/framework/entryManager/saveEntry',
      updateEntry: '/api/framework/entryManager/updateEntry',
      delEntry: '/api/framework/entryManager/delEntryConfig',
      changeStatus: '/api/framework/entryManager/changeStatus',
    },
    menuManager: {
      getParentMenu: '/api/framework/menuManager/getParentMenu',
      getAllMenuList: '/api/framework/menuManager/getAllMenuList',
      modifiedMenu: '/api/framework/menuManager/modifiedMenu',
      addMenu: '/api/framework/menuManager/addMenu',
      delMenu: '/api/framework/menuManager/delMenu'
    }
  }
}